import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import _pt from 'prop-types';
import _URL from '@babel/runtime-corejs3/core-js-stable/url';
import { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { decode } from 'qss';
import { useHistory, useLocation } from 'react-router-dom';
import { oidcStorage } from '@commercetools-frontend/application-shell-connectors';
import { u as useRedirector } from './redirector-76670a54.esm.js';
import _styled from '@emotion/styled/base';
import { themesOverrides, PublicPageLayout } from '@commercetools-frontend/application-components';
import FailedAuthenticationSVG from '@commercetools-frontend/assets/images/doors-closed.svg';
import { AsyncLocaleData } from '@commercetools-frontend/i18n';
import Card from '@commercetools-uikit/card';
import Constraints from '@commercetools-uikit/constraints';
import { customProperties, ThemeProvider } from '@commercetools-uikit/design-system';
import FlatButton from '@commercetools-uikit/flat-button';
import { AngleLeftIcon } from '@commercetools-uikit/icons';
import { ContentNotification } from '@commercetools-uikit/notifications';
import Spacings from '@commercetools-uikit/spacings';
import Text from '@commercetools-uikit/text';
import { C as ConfigureIntlProvider } from './index-bdd71e4c.esm.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import '@babel/runtime-corejs3/core-js-stable/object/keys';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import '@babel/runtime-corejs3/core-js-stable/instance/filter';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import '@babel/runtime-corejs3/core-js-stable/object/define-property';
import '@babel/runtime-corejs3/helpers/defineProperty';
import './location-f21dbc25.esm.js';
import './index-b6081c20.esm.js';
import '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import '@babel/runtime-corejs3/core-js-stable/object/entries';
import '@babel/runtime-corejs3/core-js-stable/reflect/has';
import '@reduxjs/toolkit';
import 'lodash/mapValues';
import 'omit-empty-es';
import 'redux-thunk';
import '@commercetools-frontend/constants';
import '@commercetools-frontend/notifications';
import '@commercetools-frontend/sdk';
import '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import '@babel/runtime-corejs3/core-js-stable/instance/slice';
import '@babel/runtime-corejs3/core-js-stable/instance/includes';
import '@commercetools-frontend/sentry';
import '@commercetools-frontend/react-notifications';
import '@babel/runtime-corejs3/core-js-stable/instance/starts-with';
import 'redux-logger';
import '@babel/runtime-corejs3/core-js-stable/instance/find';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';
import '@emotion/react';
import './oidc-b2520905.esm.js';
import '@babel/runtime-corejs3/core-js-stable/instance/map';
import 'react-intl';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import 'memoize-one';
import 'react-select';
import '@commercetools-uikit/accessible-hidden';
import '@commercetools-uikit/select-input';
import '@commercetools-frontend/assets/images/ct-logo.svg';
import '@commercetools-uikit/loading-spinner';
import '@commercetools-frontend/browser-history';
import '@commercetools-frontend/l10n';
import '@babel/runtime-corejs3/core-js-stable/reflect/construct';
import '@babel/runtime-corejs3/helpers/classCallCheck';
import '@babel/runtime-corejs3/helpers/createClass';
import '@babel/runtime-corejs3/helpers/inherits';
import '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import '@babel/runtime-corejs3/helpers/getPrototypeOf';
import '@babel/runtime-corejs3/core-js-stable/object/from-entries';
import '@babel/runtime-corejs3/core-js-stable/instance/flags';
import '@apollo/client/react';
import '@flopflip/combine-adapters';
import '@flopflip/http-adapter';
import '@flopflip/launchdarkly-adapter';
import '@flopflip/react-broadcast';
import '@flopflip/types';
import 'react-redux';
import '@commercetools-uikit/design-system/materials/resets.css';
import '@commercetools-frontend/application-config/ssr';
import '@commercetools-frontend/permissions';
import '@flopflip/memory-adapter';
import '@babel/runtime-corejs3/core-js-stable/json/stringify';
import '@babel/runtime-corejs3/core-js-stable/instance/some';
import '@commercetools-frontend/actions-global';

const Divider = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e57nw7s0"
} : {
  target: "e57nw7s0",
  label: "Divider"
})("box-sizing:border-box;width:100%;margin:0;border:0;border-style:solid;border-top-width:1px;border-top-color:", customProperties.colorNeutral, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm9pZGMtY2FsbGJhY2stZXJyb3ItcGFnZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBOEIwQiIsImZpbGUiOiJvaWRjLWNhbGxiYWNrLWVycm9yLXBhZ2UudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgdXNlSGlzdG9yeSB9IGZyb20gJ3JlYWN0LXJvdXRlci1kb20nO1xuaW1wb3J0IHtcbiAgUHVibGljUGFnZUxheW91dCxcbiAgdGhlbWVzT3ZlcnJpZGVzLFxufSBmcm9tICdAY29tbWVyY2V0b29scy1mcm9udGVuZC9hcHBsaWNhdGlvbi1jb21wb25lbnRzJztcbmltcG9ydCBGYWlsZWRBdXRoZW50aWNhdGlvblNWRyBmcm9tICdAY29tbWVyY2V0b29scy1mcm9udGVuZC9hc3NldHMvaW1hZ2VzL2Rvb3JzLWNsb3NlZC5zdmcnO1xuaW1wb3J0IHR5cGUgeyBUQXN5bmNMb2NhbGVEYXRhUHJvcHMgfSBmcm9tICdAY29tbWVyY2V0b29scy1mcm9udGVuZC9pMThuJztcblxuaW1wb3J0IHsgQXN5bmNMb2NhbGVEYXRhIH0gZnJvbSAnQGNvbW1lcmNldG9vbHMtZnJvbnRlbmQvaTE4bic7XG5pbXBvcnQgQ2FyZCBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC9jYXJkJztcbmltcG9ydCBDb25zdHJhaW50cyBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC9jb25zdHJhaW50cyc7XG5pbXBvcnQge1xuICBUaGVtZVByb3ZpZGVyLFxuICBjdXN0b21Qcm9wZXJ0aWVzLFxufSBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCBGbGF0QnV0dG9uIGZyb20gJ0Bjb21tZXJjZXRvb2xzLXVpa2l0L2ZsYXQtYnV0dG9uJztcbmltcG9ydCB7IEFuZ2xlTGVmdEljb24gfSBmcm9tICdAY29tbWVyY2V0b29scy11aWtpdC9pY29ucyc7XG5pbXBvcnQgeyBDb250ZW50Tm90aWZpY2F0aW9uIH0gZnJvbSAnQGNvbW1lcmNldG9vbHMtdWlraXQvbm90aWZpY2F0aW9ucyc7XG5pbXBvcnQgU3BhY2luZ3MgZnJvbSAnQGNvbW1lcmNldG9vbHMtdWlraXQvc3BhY2luZ3MnO1xuaW1wb3J0IFRleHQgZnJvbSAnQGNvbW1lcmNldG9vbHMtdWlraXQvdGV4dCc7XG5pbXBvcnQgQ29uZmlndXJlSW50bFByb3ZpZGVyIGZyb20gJy4uL2NvbmZpZ3VyZS1pbnRsLXByb3ZpZGVyJztcblxudHlwZSBUUHJvcHMgPSB7XG4gIG1lc3NhZ2U6IHN0cmluZztcbiAgbG9jYWxlOiBzdHJpbmc7XG4gIGFwcGxpY2F0aW9uTWVzc2FnZXM6IFRBc3luY0xvY2FsZURhdGFQcm9wc1snYXBwbGljYXRpb25NZXNzYWdlcyddO1xuICBjaGlsZHJlbj86IG5ldmVyO1xufTtcblxuY29uc3QgRGl2aWRlciA9IHN0eWxlZC5kaXZgXG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIHdpZHRoOiAxMDAlO1xuICBtYXJnaW46IDA7XG4gIGJvcmRlcjogMDtcbiAgYm9yZGVyLXN0eWxlOiBzb2xpZDtcbiAgYm9yZGVyLXRvcC13aWR0aDogMXB4O1xuICBib3JkZXItdG9wLWNvbG9yOiAke2N1c3RvbVByb3BlcnRpZXMuY29sb3JOZXV0cmFsfTtcbmA7XG5cbmNvbnN0IEF1dGhDYWxsYmFja0Vycm9yUGFnZSA9IChwcm9wczogVFByb3BzKSA9PiB7XG4gIGNvbnN0IGhpc3RvcnkgPSB1c2VIaXN0b3J5KCk7XG4gIHJldHVybiAoXG4gICAgPEFzeW5jTG9jYWxlRGF0YVxuICAgICAgbG9jYWxlPXtwcm9wcy5sb2NhbGV9XG4gICAgICBhcHBsaWNhdGlvbk1lc3NhZ2VzPXtwcm9wcy5hcHBsaWNhdGlvbk1lc3NhZ2VzfVxuICAgID5cbiAgICAgIHsoeyBsb2NhbGUsIG1lc3NhZ2VzIH0pID0+IChcbiAgICAgICAgPENvbmZpZ3VyZUludGxQcm92aWRlciBsb2NhbGU9e2xvY2FsZX0gbWVzc2FnZXM9e21lc3NhZ2VzfT5cbiAgICAgICAgICA8VGhlbWVQcm92aWRlclxuICAgICAgICAgICAgdGhlbWU9XCJkZWZhdWx0XCJcbiAgICAgICAgICAgIHRoZW1lT3ZlcnJpZGVzPXt0aGVtZXNPdmVycmlkZXMuZGVmYXVsdH1cbiAgICAgICAgICAvPlxuICAgICAgICAgIDxQdWJsaWNQYWdlTGF5b3V0IGNvbnRlbnRTY2FsZT1cIndpZGVcIj5cbiAgICAgICAgICAgIDxTcGFjaW5ncy5JbmxpbmUganVzdGlmeUNvbnRlbnQ9XCJjZW50ZXJcIj5cbiAgICAgICAgICAgICAgPENvbnN0cmFpbnRzLkhvcml6b250YWwgbWF4PXsxMX0+XG4gICAgICAgICAgICAgICAgPENhcmQgaW5zZXRTY2FsZT1cInhsXCI+XG4gICAgICAgICAgICAgICAgICA8U3BhY2luZ3MuU3RhY2sgc2NhbGU9XCJsXCI+XG4gICAgICAgICAgICAgICAgICAgIDxTcGFjaW5ncy5JbmxpbmUganVzdGlmeUNvbnRlbnQ9XCJjZW50ZXJcIj5cbiAgICAgICAgICAgICAgICAgICAgICA8aW1nXG4gICAgICAgICAgICAgICAgICAgICAgICB3aWR0aD1cIjEwMCVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgc3JjPXtGYWlsZWRBdXRoZW50aWNhdGlvblNWR31cbiAgICAgICAgICAgICAgICAgICAgICAgIGFsdD1cIkZhaWxlZCBhdXRoZW50aWNhdGlvblwiXG4gICAgICAgICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgICAgICAgPC9TcGFjaW5ncy5JbmxpbmU+XG4gICAgICAgICAgICAgICAgICAgIDxUZXh0LkhlYWRsaW5lIGFzPVwiaDJcIj5cbiAgICAgICAgICAgICAgICAgICAgICB7J0F1dGhlbnRpY2F0aW9uIGVycm9yJ31cbiAgICAgICAgICAgICAgICAgICAgPC9UZXh0LkhlYWRsaW5lPlxuICAgICAgICAgICAgICAgICAgICA8Q29udGVudE5vdGlmaWNhdGlvbiB0eXBlPVwiZXJyb3JcIj5cbiAgICAgICAgICAgICAgICAgICAgICA8U3BhY2luZ3MuU3RhY2sgc2NhbGU9XCJtXCI+XG4gICAgICAgICAgICAgICAgICAgICAgICA8VGV4dC5Cb2R5Pntwcm9wcy5tZXNzYWdlfTwvVGV4dC5Cb2R5PlxuICAgICAgICAgICAgICAgICAgICAgIDwvU3BhY2luZ3MuU3RhY2s+XG4gICAgICAgICAgICAgICAgICAgIDwvQ29udGVudE5vdGlmaWNhdGlvbj5cbiAgICAgICAgICAgICAgICAgICAgPFNwYWNpbmdzLlN0YWNrIHNjYWxlPVwibVwiPlxuICAgICAgICAgICAgICAgICAgICAgIDxEaXZpZGVyIC8+XG4gICAgICAgICAgICAgICAgICAgICAgPEZsYXRCdXR0b25cbiAgICAgICAgICAgICAgICAgICAgICAgIGxhYmVsPVwiVHJ5IGxvZyBpbiBhZ2FpblwiXG4gICAgICAgICAgICAgICAgICAgICAgICBpY29uPXs8QW5nbGVMZWZ0SWNvbiAvPn1cbiAgICAgICAgICAgICAgICAgICAgICAgIG9uQ2xpY2s9eygpID0+IHtcbiAgICAgICAgICAgICAgICAgICAgICAgICAgaGlzdG9yeS5wdXNoKCcvJyk7XG4gICAgICAgICAgICAgICAgICAgICAgICB9fVxuICAgICAgICAgICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICAgICAgICAgIDwvU3BhY2luZ3MuU3RhY2s+XG4gICAgICAgICAgICAgICAgICA8L1NwYWNpbmdzLlN0YWNrPlxuICAgICAgICAgICAgICAgIDwvQ2FyZD5cbiAgICAgICAgICAgICAgPC9Db25zdHJhaW50cy5Ib3Jpem9udGFsPlxuICAgICAgICAgICAgPC9TcGFjaW5ncy5JbmxpbmU+XG4gICAgICAgICAgPC9QdWJsaWNQYWdlTGF5b3V0PlxuICAgICAgICA8L0NvbmZpZ3VyZUludGxQcm92aWRlcj5cbiAgICAgICl9XG4gICAgPC9Bc3luY0xvY2FsZURhdGE+XG4gICk7XG59O1xuQXV0aENhbGxiYWNrRXJyb3JQYWdlLmRpc3BsYXlOYW1lID0gJ0F1dGhDYWxsYmFja0Vycm9yUGFnZSc7XG5cbmV4cG9ydCBkZWZhdWx0IEF1dGhDYWxsYmFja0Vycm9yUGFnZTtcbiJdfQ== */"));
const AuthCallbackErrorPage = props => {
  const history = useHistory();
  return jsx(AsyncLocaleData, {
    locale: props.locale,
    applicationMessages: props.applicationMessages,
    children: _ref => {
      let locale = _ref.locale,
        messages = _ref.messages;
      return jsxs(ConfigureIntlProvider, {
        locale: locale,
        messages: messages,
        children: [jsx(ThemeProvider, {
          theme: "default",
          themeOverrides: themesOverrides.default
        }), jsx(PublicPageLayout, {
          contentScale: "wide",
          children: jsx(Spacings.Inline, {
            justifyContent: "center",
            children: jsx(Constraints.Horizontal, {
              max: 11,
              children: jsx(Card, {
                insetScale: "xl",
                children: jsxs(Spacings.Stack, {
                  scale: "l",
                  children: [jsx(Spacings.Inline, {
                    justifyContent: "center",
                    children: jsx("img", {
                      width: "100%",
                      src: FailedAuthenticationSVG,
                      alt: "Failed authentication"
                    })
                  }), jsx(Text.Headline, {
                    as: "h2",
                    children: 'Authentication error'
                  }), jsx(ContentNotification, {
                    type: "error",
                    children: jsx(Spacings.Stack, {
                      scale: "m",
                      children: jsx(Text.Body, {
                        children: props.message
                      })
                    })
                  }), jsxs(Spacings.Stack, {
                    scale: "m",
                    children: [jsx(Divider, {}), jsx(FlatButton, {
                      label: "Try log in again",
                      icon: jsx(AngleLeftIcon, {}),
                      onClick: () => {
                        history.push('/');
                      }
                    })]
                  })]
                })
              })
            })
          })
        })]
      });
    }
  });
};
AuthCallbackErrorPage.displayName = 'AuthCallbackErrorPage';

const OidcCallback = props => {
  const location = useLocation();
  const redirector = useRedirector();
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    message = _useState2[0],
    setMessage = _useState2[1];
  const fragments = decode(location.hash.substring(1));
  const sessionToken = fragments.sessionToken;
  useEffect(() => {
    // Validate the nonce (coming as a `state` parameter)
    // By trying to load the related session state, we can implicitly check if the nonce is correct or not.
    const sessionState = oidcStorage.getSessionState(fragments.state);
    let errorMessage;
    let decodedSessionToken;
    try {
      if (sessionToken) {
        decodedSessionToken = jwtDecode(sessionToken);
      } else {
        errorMessage = 'Invalid client session (missing sessionToken)';
      }
    } catch (err) {
      if (err instanceof Error) {
        errorMessage = err.message;
      } else {
        errorMessage = 'Unknown error';
      }
    }
    if (!errorMessage) {
      const hasValidSessionId = decodedSessionToken?.nonce === fragments.state;
      const hasValidApplicationId = window.app.applicationId === sessionState?.applicationId;
      if (!sessionState || !hasValidSessionId || !hasValidApplicationId) {
        errorMessage = 'Invalid client session';
      }
    }
    if (errorMessage) {
      setMessage(errorMessage);
    } else {
      oidcStorage.setActiveSession(sessionToken);
      oidcStorage.removeSessionState(fragments.state);
      if (sessionState?.query.redirectTo) {
        try {
          const redirectToUrl = new _URL(sessionState.query.redirectTo);
          redirector({
            to: redirectToUrl.pathname
          });
          return;
        } catch (error) {
          console.warn(`Invalid "redirectTo" URL`, sessionState.query.redirectTo);
          // ignore
        }
      }
      redirector({
        to: location.pathname.replace('/oidc/callback', '')
      });
      return;
    }

    // Only execute once!
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (message) {
    return jsx(AuthCallbackErrorPage, {
      message: message,
      locale: props.locale,
      applicationMessages: props.applicationMessages
    });
  }
  return null;
};
OidcCallback.propTypes = process.env.NODE_ENV !== "production" ? {
  locale: _pt.string.isRequired
} : {};
OidcCallback.displayName = 'OidcCallback';

export { OidcCallback as default };
